import { api } from '@ai/common/src/api/axios';

class UserService {
  private baseUrl = '/platform/api/v1/user';

  setSupervisorOnline = async (online: boolean) =>
    await api.put(`${this.baseUrl}/supervisor_online`, { online });
}

export const userService = new UserService();
